module.exports = __webpack_public_path__ + "static/media/5.021ca6dd.jpg";